import { BrowserRouter } from 'react-router';
import { AppProviders } from '@/app/providers';
import { AppRoutes } from '@/app/router';

export const App = () => (
  <BrowserRouter>
    <AppProviders>
      <AppRoutes />
    </AppProviders>
  </BrowserRouter>
);
